import { Color3 } from '@babylonjs/core/Maths/math';
var ConfigurationContainer = /** @class */ (function () {
    function ConfigurationContainer() {
        this.mainColor = Color3.White();
        this.reflectionColor = Color3.White();
    }
    return ConfigurationContainer;
}());
export { ConfigurationContainer };
//# sourceMappingURL=configurationContainer.js.map